import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const teamMembers = [
  {
    name: 'Josh Payne',
    role: 'Director, Resources & Capital Partnerships',
    image: '/images/josh-payne.jpg',
  },
  {
    name: 'Andy Carey',
    role: 'Director, Strategic Finance, Risk & Insurance',
    image: '/images/andy-carey.jpg',
  },
];

const TeamPreview = () => {
  return (
    <section id="team" className="relative z-10 max-w-6xl mx-auto px-6 py-20">
      <div className="text-center mb-14">
        <div className="text-xs uppercase tracking-[0.25em] text-[#8b5a2b] font-medium mb-4">The people</div>
        <h2 className="text-4xl md:text-5xl font-semibold tracking-[-0.025em] text-[#2a2420]">
          The <span className="font-serif-display italic font-medium text-[#8b5a2b]">success</span> team.
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
        {teamMembers.map((member) => (
          <Link
            key={member.name}
            to="/team"
            className="group relative p-8 rounded-3xl bg-white/60 backdrop-blur-xl border border-white/80 shadow-[0_8px_32px_-12px_rgba(80,50,20,0.12)] hover:shadow-[0_16px_48px_-12px_rgba(80,50,20,0.2)] hover:-translate-y-1 hover:bg-white/80 transition-all duration-500 flex flex-col items-center text-center"
          >
            <div className="absolute -top-20 -right-20 w-48 h-48 rounded-full bg-gradient-to-br from-amber-200/40 to-rose-200/30 blur-2xl opacity-70 group-hover:opacity-100 transition-opacity duration-700" />
            <div className="relative w-36 h-36 mb-6 overflow-hidden rounded-full border-4 border-white/90 shadow-lg">
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <h3 className="relative text-xl font-semibold tracking-[-0.015em] text-[#2a2420] mb-2">
              {member.name}
            </h3>
            <p className="relative text-[#8b5a2b] text-xs uppercase tracking-[0.15em] mb-4">
              {member.role}
            </p>
            <div className="relative flex items-center gap-1.5 text-sm text-[#8b5a2b] font-medium opacity-60 group-hover:opacity-100 transition-opacity">
              View profile <ArrowUpRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </div>
          </Link>
        ))}
      </div>

      <div className="text-center mt-12">
        <Link
          to="/team"
          className="group inline-flex items-center gap-2 bg-[#2a2420] hover:bg-[#1a1410] text-[#fbf8f3] text-sm font-medium px-7 py-3 rounded-full transition-all hover:scale-[1.02] active:scale-[0.98]"
        >
          Meet the full team
          <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
        </Link>
      </div>
    </section>
  );
};

export default TeamPreview;
